import axios, { AxiosError, AxiosResponse } from "axios";
import { ApiResponse, ApiResponseClass, createApiResponseFromCaughtError } from "api/api";

export async function get(url: string) {
  let response = await axios.get(url);
  return createApiResponseFromAxiosResponse(response);
}

export async function post<R = any, D = any>(url: string, postBody: D) : Promise<ApiResponse<R>> {
  const response = await axios.post(url, postBody);
  return createApiResponseFromAxiosResponse(response);
}

export function createApiResponseFromAxiosError<T = any, D = any>(axiosError: AxiosError<T, D>) : ApiResponse<T> {
  var axiosResponse = axiosError.response;
  if (axiosResponse) {
    var apiResponse = createApiResponseFromAxiosResponse(axiosResponse);
    apiResponse.statusText = apiResponse.data as string;
    return apiResponse;
  }
  return createApiResponseFromCaughtError(axiosError);
}

export function createApiResponseFromAxiosResponse<T = any, D = any>(axiosResponse: AxiosResponse<T, D>) : ApiResponse<T> {
  let headers: {[key: string]: string;} = {};
  for (const header in axiosResponse.headers) {
    headers[header] = axiosResponse.headers[header];
  }
  return new ApiResponseClass(
    headers,
    axiosResponse.status,
    axiosResponse.statusText,
    axiosResponse.data
  );
}